import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { WarningCircleIcon } from '@synoptic/ui-kit/icons/react/warning-circle.tsx';
import {
  ModalContent,
  ModalHeader,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.tsx';
import { FC } from 'react';
import {
  actionButtons,
  addInfoContainer,
  addInfoContent,
  content,
  iconContainer,
  warning,
} from './delete-stream-modal.css.ts';

export type DeleteStreamModalContentProps = {
  onCancel: () => void;
  onDelete: () => void;
  isPaid: boolean;
  entityName: string;
};

export const DeleteStreamModalContent: FC<DeleteStreamModalContentProps> = ({
  onCancel,
  onDelete,
  isPaid,
  entityName,
}) => {
  return (
    <ModalContent>
      <ModalHeader>
        <ModalTitle startIcon={<WarningCircleIcon />}>
          Delete {entityName}
        </ModalTitle>
      </ModalHeader>

      <span className={content}>
        If you delete this {entityName}, any information associated to this data
        stream will be deleted and cannot be recovered.
      </span>
      {isPaid ? (
        <div className={addInfoContainer}>
          <div className={iconContainer}>
            <WarningCircleIcon />
          </div>
          <span className={addInfoContent}>
            Note that the current period of subscription will be refunded to
            subscribers according to the Synoptic&apos;s refund policy.
          </span>
        </div>
      ) : null}
      <div className={warning}>Warning, this action cannot be undone.</div>
      <div className={actionButtons}>
        <Button size={'large'} variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button size={'large'} variant={'critical'} onClick={onDelete}>
          Delete
        </Button>
      </div>
    </ModalContent>
  );
};
